/* Proteinak custom theme — storefront JS (vanilla, no deps) */
(function () {
  'use strict';
  var root = document.documentElement;
  var overlay = document.getElementById('pk-overlay');
  var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'JOD';

  /* ---------- Arabic strings (injected from theme.liquid, Arabic fallbacks) ---------- */
  var S = window.PKStrings || {};
  var T = {
    cart_empty: S.cart_empty || 'سلتك فارغة',
    shop_now: S.shop_now || 'تسوّق الآن',
    remove: S.remove || 'إزالة',
    decrease: S.decrease || 'تقليل الكمية',
    increase: S.increase || 'زيادة الكمية',
    adding: S.adding || 'جارٍ الإضافة…',
    added: S.added || 'تمت الإضافة إلى السلة',
    add_to_cart: S.add_to_cart || 'أضف إلى السلة',
    sold_out: S.sold_out || 'نفدت الكمية',
    max_stock: S.max_stock || 'المتوفر @@ قطعة فقط',
    error_add: S.error_add || 'تعذّرت الإضافة إلى السلة',
    error_network: S.error_network || 'خطأ في الاتصال، حاول مرة أخرى',
    free_shipping_unlocked: S.free_shipping_unlocked || 'لقد حصلت على توصيل مجاني!',
    free_shipping_remaining: S.free_shipping_remaining || 'تبقّى @@ للحصول على توصيل مجاني',
    all_products_url: S.all_products_url || '/collections/all'
  };

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    return v + ' ' + money;
  }
  function lockScroll(on) { document.body.style.overflow = on ? 'hidden' : ''; }

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-active'); }); }
    lockScroll(true);
  }
  function closePanels() {
    $all('.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    if (overlay) { overlay.classList.remove('is-active'); setTimeout(function () { overlay.hidden = true; }, 300); }
    lockScroll(false);
  }
  if (overlay) overlay.addEventListener('click', closePanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2600);
  }

  /* ---------- triggers ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pk]');
    if (!t) return;
    var action = t.getAttribute('data-pk');
    if (action === 'cart-open') { e.preventDefault(); openCart(); }
    else if (action === 'menu-open') { e.preventDefault(); openPanel($('.mobile-menu')); }
    else if (action === 'filters-open') { e.preventDefault(); openPanel($('.filters')); }
    else if (action === 'search-open') { e.preventDefault(); var m = $('.search-modal'); if (m) { m.classList.add('is-open'); if (overlay) { overlay.hidden = false; requestAnimationFrame(function(){overlay.classList.add('is-active');}); } lockScroll(true); var i = $('input[type=search]', m); if (i) i.focus(); } }
    else if (action === 'close') { e.preventDefault(); closePanels(); }
  });

  /* ---------- cart ---------- */
  function openCart() {
    var drawer = $('.cart-drawer');
    if (!drawer) { window.location.href = '/cart'; return; }
    refreshCart().then(function () { openPanel(drawer); });
  }

  function renderCart(cart) {
    var count = cart.item_count;
    $all('.cart-count').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
    var items = $('.cart-drawer__items');
    var foot = $('.cart-drawer__foot');
    if (!items) return;
    if (count === 0) {
      items.innerHTML = '<div class="cart-empty"><p>' + T.cart_empty + '</p><a class="btn btn--primary" href="' + T.all_products_url + '">' + T.shop_now + '</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    items.innerHTML = cart.items.map(function (it) {
      return '<div class="cart-line" data-key="' + it.key + '">' +
        '<a class="cart-line__img" href="' + it.url + '"><img src="' + (it.image ? it.image : '') + '" alt="" loading="lazy"></a>' +
        '<div><a class="cart-line__title" href="' + it.url + '">' + it.product_title + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="text-muted" style="font-size:.8rem">' + it.variant_title + '</div>' : '') +
        '<div class="qty" data-key="' + it.key + '" style="margin-top:8px"><button data-qd="-1" aria-label="' + T.decrease + '">&minus;</button><input type="text" value="' + it.quantity + '" readonly><button data-qd="1" aria-label="' + T.increase + '">+</button></div>' +
        '<button class="cart-line__remove" data-remove="' + it.key + '">' + T.remove + '</button></div>' +
        '<div class="price">' + formatMoney(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    var sub = $('.cart-drawer__subtotal');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    updateFreeBar(cart.total_price);
  }

  function updateFreeBar(total) {
    var bar = $('.freebar');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) * 100;
    if (!threshold) { bar.hidden = true; return; }
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var fill = $('.freebar__fill', bar);
    var label = $('.freebar__label', bar);
    if (fill) fill.style.width = pct + '%';
    if (label) {
      if (total >= threshold) label.textContent = T.free_shipping_unlocked;
      else label.textContent = T.free_shipping_remaining.replace('@@', formatMoney(threshold - total));
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        // Shopify refuses quantities above stock; show its message and redraw the real cart
        if (!res.ok) { toast(res.d.description || res.d.message || T.error_add); return refreshCart(); }
        renderCart(res.d);
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-remove'), 0); return; }
    var qd = e.target.closest('[data-qd]');
    if (qd) {
      e.preventDefault();
      var line = qd.closest('.cart-line');
      if (!line) return;
      var input = $('input', qd.parentNode);
      var newQ = Math.max(0, parseInt(input.value, 10) + parseInt(qd.getAttribute('data-qd'), 10));
      changeLine(line.getAttribute('data-key'), newQ);
    }
  });

  /* ---------- product add to cart ---------- */
  $all('form[action$="/cart/add"], form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.hasAttribute('data-no-ajax')) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.setAttribute('disabled', ''); btn.innerHTML = T.adding; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = label; }
          if (!res.ok) {
            toast(res.d.description || res.d.message || T.error_add);
            // Shopify may still have added the available amount (e.g. 5 of 40), so show the real cart
            refreshCart().then(function (cart) { if (cart && cart.item_count && $('.cart-drawer')) openCart(); });
            return;
          }
          refreshCart().then(function () {
            if ($('.cart-drawer')) openCart(); else toast(T.added);
          });
        })
        .catch(function () { if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = label; } toast(T.error_network); });
    });
  });

  /* ---------- product page qty ---------- */
  var MAX_STOCK_MSG = T.max_stock;
  // Arabic-Indic and Persian digits -> 0-9, then drop anything that is not a digit
  function qtyDigits(s) {
    return String(s)
      .replace(/[\u0660-\u0669]/g, function (d) { return d.charCodeAt(0) - 0x0660; })
      .replace(/[\u06F0-\u06F9]/g, function (d) { return d.charCodeAt(0) - 0x06F0; })
      .replace(/\D/g, '');
  }
  function clampQty(input, announce) {
    var max = parseInt(input.getAttribute('data-max'), 10);
    var v = parseInt(qtyDigits(input.value), 10);
    if (isNaN(v) || v < 1) v = 1;
    if (!isNaN(max) && v > Math.max(1, max)) {
      v = Math.max(1, max);
      if (announce && max > 0) toast(MAX_STOCK_MSG.replace('@@', max));
    }
    input.value = v;
    return v;
  }
  $all('.qty').forEach(function (q) {
    if (q.closest('.cart-line')) return;
    var input = $('input', q);
    if (!input) return;
    q.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qd]'); if (!b) return;
      input.value = (parseInt(qtyDigits(input.value), 10) || 1) + parseInt(b.getAttribute('data-qd'), 10);
      clampQty(input, true);
    });
    input.addEventListener('focus', function () { input.select(); });
    input.addEventListener('input', function () {
      var clean = qtyDigits(input.value);
      if (clean !== input.value) input.value = clean;
    });
    input.addEventListener('change', function () { clampQty(input, true); });
    input.addEventListener('blur', function () { clampQty(input, false); });
    // Enter submits the form, so settle the number first
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') clampQty(input, true); });
  });

  /* ---------- product variants ---------- */
  $all('[data-product-form]').forEach(function (wrap) {
    var data = wrap.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = wrap.querySelector('input[name="id"]');
    var priceEl = wrap.querySelector('[data-price]');
    var btn = wrap.querySelector('[type=submit]');
    var stockEl = wrap.querySelector('[data-stock]');
    var stock = stockEl ? JSON.parse(stockEl.textContent) : {};
    var qtyInput = wrap.querySelector('input[name="quantity"]');
    function selectedOptions() {
      return $all('[data-opt]', wrap).map(function (group) {
        var checked = group.querySelector('input:checked') || group.querySelector('select');
        return checked ? checked.value : null;
      });
    }
    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      if (!match) return;
      idInput.value = match.id;
      if (qtyInput) {
        var cap = stock[match.id];
        if (cap != null) {
          qtyInput.setAttribute('data-max', cap);
          if (parseInt(qtyInput.value, 10) > cap) qtyInput.value = Math.max(1, cap);
        } else {
          qtyInput.removeAttribute('data-max');
        }
      }
      if (priceEl) priceEl.innerHTML = formatMoney(match.price);
      var imgChange = wrap.getAttribute('data-gallery');
      if (match.featured_image && imgChange) {
        var main = $('#pk-main-img');
        if (main) main.src = match.featured_image.src;
      }
      if (btn) {
        if (match.available) { btn.removeAttribute('disabled'); btn.innerHTML = btn.getAttribute('data-add') || T.add_to_cart; }
        else { btn.setAttribute('disabled', ''); btn.innerHTML = T.sold_out; }
      }
    }
    wrap.addEventListener('change', update);
    update();
  });

  /* ---------- product gallery thumbs ---------- */
  $all('.product__thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = $('#pk-main-img');
      if (main) main.src = b.getAttribute('data-full');
      $all('.product__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
    });
  });

  /* ---------- header scroll ---------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- scroll reveal ---------- */
  var reveals = $all('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(function (el, i) { el.style.transitionDelay = (i % 6) * 55 + 'ms'; io.observe(el); });
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-in'); }); }, 1800);
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* init cart count on load */
  refreshCart();
})();
